<form #policyRuleForm="ngForm" (ngSubmit)="policyRuleForm.valid && close()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="row">
            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm.submitted )}">
                    <label class="col-form-label text-bold"><span translate>Rule name</span>*</label>
                    <div>
                        <form-field-input name="name" [(ngModel)]="cRule.name" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.form.get('name')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48 mt-2">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm.submitted )}">
                    <label class="col-form-label text-bold" for="query" translate>Search for file size that is</label>:
                    <div class="input-group">
                        <mon-action-menu
                            *ngIf="cRule.operator"
                            class="rule-menu-action"
                            [monActionMenuItems]="dropdownOptions"
                            [monActionMenuClass]="'menu-panel-left-align'"
                            >{{selectedOperator?.translation}}</mon-action-menu>

                        <input name="query"
                               data-test="query-starts-with"
                               [required]="true"
                               [(ngModel)]="cRule.query"
                               #queryFormControl="ngModel"
                               id="query"
                               type="number"
                               [min]="0"
                               class="form-control"/>

                        <mon-action-menu
                                class="rule-menu-action"
                                [monActionMenuItems]="dropdownSizeOptions"
                                >{{selectedSize?.name}}</mon-action-menu>
                    </div>
                    <div class="help-block" translate>
                        Define size of files to look for
                    </div>
                    <form-field-errors [input]="queryFormControl" offset="0"></form-field-errors>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <div class="row">
            <div class="col-48 text-right">
                <button type="submit"
                        class="btn btn-border-radius btn-secondary"
                        [disabled]="policyRuleForm.invalid"
                        translate>
                    Save
                </button>
            </div>
        </div>
    </div>
</form>
